export const formatPhoneNumber = (phoneNumber: string) => {
  // Input must be in E.164 format, eg: +16092136175 => +1 (609) 213-6175
  const match = phoneNumber.match(/^\+(\d+)(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const [, countryCode, areaCode, part1, part2] = match;
    return `+${countryCode} (${areaCode}) ${part1}-${part2}`;
  }
  return phoneNumber; // Return original if not matching expected format
};

export const formatPhoneNumberWithExtension = (
  phoneNumber: string,
  extension?: string
) => {
  return `${formatPhoneNumber(phoneNumber)}${
    extension ? ` x${extension}` : ''
  }`;
};
